import { useMutation, useQueryClient } from '@tanstack/react-query';
import { publishApp } from 'api/appManager';
import { LIST_APP_DETAIL_QUERY, LIST_APP_QUERY } from 'constants/QueryString';

const usePublishApp = () => {
  const queryClient = useQueryClient();

  const {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
  } = useMutation({
    mutationFn: publishApp,
    onSuccess: (data) => {
      queryClient.invalidateQueries([LIST_APP_DETAIL_QUERY, data.Id]);
    },
    onError: (error) => {
      console.error('Error creating user:', error);
      // Handle the error, show error message, etc.
    },
  });
  return {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
  };
};

export default usePublishApp;
